import {datatables} from '#/js/inline/datatables';

export default function() {
  datatables();
  const listTable = $('#channelList');
  listTable.DataTable({
    dom: 'Bfrtip',
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print',
    ],
    language: {
      search: "_INPUT_",
      searchPlaceholder: window.Lang.get('general.search') + '...',
    },
  });
}
